<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div class="header">
        <h1 class="title">Replacements</h1>
        <div class="buttonsGroup">
          <b-tooltip label="Add a Replacement" position="is-bottom"
            ><button class="button is-medium is-info" @click="isNewItemActive = true">
              <b-icon icon="plus" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Edit a Replacement" position="is-bottom"
            ><button class="button is-medium is-info" @click="EditItem()">
              <b-icon icon="pencil" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Delete a Replacement" position="is-left"
            ><button class="button is-medium is-danger" @click="DeleteItem()">
              <b-icon icon="trash" size="is-small"></b-icon></button
          ></b-tooltip>
        </div>
      </div>
      <template>
        <b-table :data="this.replacements" :selected.sync="selected" :loading="this.isLoading" hoverable sticky-header>
          <b-table-column field="search" label="Search String" sortable v-slot="props">
            {{ props.row.search }}
          </b-table-column>
          <b-table-column field="replacement" label="Replacement" sortable v-slot="props">
            {{ props.row.replacement }}
          </b-table-column>
          <b-table-column field="replace_type" label="Replacement Type" sortable v-slot="props">
            {{ props.row.replace_type }}
          </b-table-column>
          <b-table-column field="context" label="Context" sortable v-slot="props">
            {{
              contexts.filter((context) => {
                return context.context_id === props.row.context_id;
              })[0].context_name
            }}
          </b-table-column>
          <b-table-column field="author" label="Author" sortable v-slot="props">
            {{ props.row.author }}
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                </p>
                <p>Looks like there aren't any replacements</p>
              </div>
            </section>
          </template>
        </b-table>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <replacement @submitted="AddNewItem" :selected="this.formProps" :contexts="this.contexts" :heading="'Add Replacement'"></replacement>
        </b-modal>
        <b-modal :active.sync="isEditItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <replacement @submitted="UpdateItem" :selected="this.editableSelected" :contexts="this.contexts" :heading="'Edit Replacement'"></replacement>
        </b-modal>
      </template>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

const Replacement = {
  props: {
    selected: {
      type: Object,
      required: false,
    },
    contexts: {
      type: Array,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
  },
  mounted: function () {
    if (!this.selected.replacement) this.selected.replacement = "";
  },
  data: function () {
    return {
      string_pos: ["start", "beginning + middle", "middle", "middle + end", "end", "number + word + blank", "in-between", "regex", "replaceAll"],
    };
  },
  mounted: function () {
    if (!this.selected.replacement) this.selected.replacement = "";
  },
  methods: {
    capitalizeFirstLetter: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    submit: function () {
      this.$emit("submitted");
    },
  },
  template: `
            <form action="#" v-on:submit.prevent="submit">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{ heading }}</p>
                    </header>
                    <section class="modal-card-body">
                        <b-field label="Search">
                            <b-input
                                type="text"
                                placeholder="e.g. mn street"
                                v-model="selected.search"
                                required>
                            </b-input>
                        </b-field>

                        <b-field label="Replacement">
                            <b-input
                                type="text"
                                placeholder="e.g. main street"
                                v-model="selected.replacement"
                                >
                            </b-input>
                        </b-field>

                        <b-field label="Replacement Type" v-model="selected.replace_type">
                          <b-radio v-model="selected.replace_type"
                              native-value="fullstring" name="replacement_type" required>
                              Full string
                          </b-radio>
                          <b-radio v-model="selected.replace_type"
                              native-value="substring" name="replacement_type" required>
                              Substring
                          </b-radio>
                        </b-field>

                        <b-field label= "Position" v-model="selected.string_pos" v-if="selected.replace_type == 'substring'">
                          <b-select placeholder="Select replacement type" v-model="selected.string_pos" required>
                          <option
                              v-for="position in string_pos"
                              :value="position">
                              {{ capitalizeFirstLetter(position) }}
                            </option>
                          </b-select>
                        </b-field>

                        <b-field label="Module">
                          <b-select placeholder="Select replacement type" v-model="selected.context_id" required>
                          <option
                              v-for="context in contexts"
                              :value="context.context_id">
                              {{ context.context_name }}
                            </option>
                          </b-select>
                        </b-field>

                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="$parent.close()">Cancel</button>
                        <button class="button is-primary" type="submit">Submit</button>
                    </footer>
                </div>
            </form>
        `,
};

export default {
  components: {
    Replacement,
  },
  data: function () {
    return {
      replacements: [],
      contexts: [],
      selected: {},
      editableSelected: {},
      isLoading: true,
      isNewItemActive: false,
      isEditItemActive: false,
      formProps: {},
      newApiUrl: "https://api.jeak.co.uk",
    };
  },
  methods: {
    GetReplacements: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      this.isLoading = true;
      axios.get(this.newApiUrl + `/replacements`, config).then((response) => {
        this.replacements = response.data;
        this.isLoading = false;
      });
    },
    GetContexts: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.newApiUrl + `/replacements/contexts`, config).then((response) => {
        this.contexts = response.data;
      });
    },
    AddNewItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.post(this.newApiUrl + `/replacements`, this.formProps, config).then((response) => {
        this.isNewItemActive = false;
        this.GetReplacements();
      });
    },
    UpdateItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.put(this.newApiUrl + `/replacements/${this.editableSelected.id}`, this.editableSelected, config).then((response) => {
        this.isEditItemActive = false;
        this.GetReplacements();
      });
    },
    EditItem: async function () {
      Object.assign(this.editableSelected, this.selected);
      this.isEditItemActive = true;
    },
    DeleteItem: async function () {
      this.$buefy.dialog.confirm({
        title: "Deleting Replacement",
        message: "Are you sure you want to <b>delete</b> this replacement? This action cannot be undone.",
        confirmText: "Delete Replacement",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          const token = await this.$cognitoAuth.getIdToken();
          const config = {
            headers: { Authorization: `Bearer ` + token },
          };
          axios.delete(this.newApiUrl + `/replacements/${this.selected.id}`, config).then((response) => {
            this.GetReplacements();
            this.$buefy.toast.open("Replacement deleted!");
          });
        },
      });
    },
  },
  mounted() {
    this.GetContexts();
    this.GetReplacements();
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}
.header h1 {
  grid-column: 1/8;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.b-table {
  height: 100%;
}
</style>
